import PropTypes from 'prop-types'
import styles from './styles.module.css'

export const SecondaryButton = ({
  children,
  onClick,
  disabled = false,
  size = 'medium', // 'small' | 'medium' | 'large'
  className,
  type = 'button',
  ...props
}) => {
  const sizeClass = {
    small: styles.button_size_small,
    medium: styles.button_size_medium,
    large: styles.button_size_large,
  }[size]

  return (
    <button
      type={type}
      className={`${styles.button_secondary_base} ${sizeClass} ${className || ''}`}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}

SecondaryButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
}
